/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IInventoryImportRequest } from '../models/IInventoryImportRequest';
import type { IInventoryImportResolveRequest } from '../models/IInventoryImportResolveRequest';
import type { IInventoryItemSansLocations } from '../models/IInventoryItemSansLocations';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class InventoryItemsImportService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns IInventoryItemSansLocations
     * @throws ApiError
     */
    public postInventoryItemsImportResolve({
        requestBody,
    }: {
        requestBody: IInventoryImportResolveRequest,
    }): CancelablePromise<Array<IInventoryItemSansLocations>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/inventory/items/import/resolve',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public postInventoryItemsImportImport({
        requestBody,
    }: {
        requestBody: IInventoryImportRequest,
    }): CancelablePromise<{
        ok: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/inventory/items/import',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
